import { trackEvent } from '@/utils/analytics'

/**
 * Toggle the board leftnav (FS-513). Flips the expanded state and emits exactly
 * one `board-leftnav_toggled` analytics event with the resolved next value and
 * the current board id.
 *
 * Extracted from BoardCanvas so the load-bearing wiring — flip the rail state,
 * emit telemetry, and crucially do NOT navigate away from the board (the
 * original bug) — is unit-testable without rendering the ~2.4k-line tldraw
 * board component. The `next` value is resolved from the passed `expanded`
 * (the committed render value), not inside a state updater, so the analytics
 * side effect stays out of React's pure update path.
 */
export function toggleBoardSidebar(args: {
  expanded: boolean
  setExpanded: (next: boolean) => void
  boardId: string | undefined
}): void {
  const next = !args.expanded
  args.setExpanded(next)
  trackEvent('board-leftnav_toggled', { expanded: next, board_id: args.boardId })
}
